<template>
  <div id="app"
       class="main-app">
    <!--公共导航栏组件-->
    <switch-tabs v-if="!hidden"
                 :tableList="tableList"
                 class="nav-bar" />
    <!--路由视图-->
    <div style="padding: 68px 0"
         class="main-app">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
    <div class="Polaris-FooterHelp"
         v-if="!hidden">
      <div class="Polaris-FooterHelp__Content">
        <div class="Polaris-FooterHelp__Icon">
          <span class="
              Polaris-Icon Polaris-Icon--colorHighlight Polaris-Icon--applyColor
            "><svg viewBox="0 0 20 20"
                 class="Polaris-Icon__Svg"
                 focusable="false"
                 aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-9 3a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0v2zm0-6a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"></path>
            </svg></span>
        </div>
        <div class="Polaris-FooterHelp__Text">
          Learn more about
          <a target="_blank"
             class="Polaris-Link"
             href="https://helpcenterapi.sealapps.com/help/app/article/3/46"
             rel="noopener noreferrer"
             data-polaris-unstyled="true">BOGO Cross Sell&Upsell bundles</a>
        </div>
      </div>
    </div>
    <div id="PolarisPortalsContainer"></div>
  </div>
</template>

<script>
import createApp from '@shopify/app-bridge'
import SwitchTabs from '@/components/SwitchTabs'
import '@/assets/css/styles6.3.0.css'
import '@/assets/css/common.css'
import '@/assets/css/helper.css'
import utilIndex from '@/utils'
import authIndex from '@/utils/auth'
import PostLayer from './components/PostLayer/PostLayer.vue'
import { sessionSave, sessionRead } from '@/utils/util'

export default {
  name: 'App',
  components: {
    'switch-tabs': SwitchTabs,
    PostLayer,
  },
  created() {
    this.iniWilldesk();
    let host = utilIndex.getUrlKey('host')
    if (host || utilIndex.getEnv() == 'dev' || authIndex.getShopToken()) {
      // 初始化菜单
      this.parseRouter(this.$router.options.routes)
      // 初始化验证的数据
      this.initAuth()
    }
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionRead('store') && sessionRead('store') != '') {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, JSON.parse(sessionRead('store')))
      )
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      window.name = this.$local.get()
      sessionSave('store', JSON.stringify(this.$store.state))
    })
  },
  mounted() {
    var text = `
        Version_time is ${API_CONFIG.VERSION_TIME}
            __  __     ____         _       __           __    __
            / / / /__  / / /___     | |     / /___  _____/ /___/ /
          / /_/ / _ \\/ / / __ \\    | | /| / / __ \\/ ___/ / __  / 
          / __  /  __/ / / /_/ /    | |/ |/ / /_/ / /  / / /_/ /  
        /_/ /_/\\___/_/_/\\____/     |__/|__/\\____/_/  /_/\\__,_/   
        `
    console.log(text)
  },
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      hidden: false, //TODO 是否隐藏公共组件，此功能还未做
      tableList: [],
      // 是否显示路由视图
      isRouterAlive: true,
    }
  },
  methods: {
    parseRouter(params, prefix = '') {
      params.forEach((v) => {
        let _path =
          v.path.indexOf('/') === 0 ? prefix + v.path : prefix + '/' + v.path
        if (v.hidden === false) {
          if (v.children) {
            this.parseRouter(v.children, _path)
          } else {
            this.tableList.push({
              title: v.meta.title,
              urlStatus: v.meta.urlStatus ?? _path,
              path: _path,
            })
          }
        }
      })
    },
    initAuth() {
      let shopOrigin = utilIndex.getUrlKey('shop') || authIndex.getShopToken() //Shopify 重定向过来，携带了这些参数
      if (!shopOrigin) {
        return false
      }
      this.$store.commit('setShopDomain', shopOrigin) //保存店铺域名
      authIndex.setShopToken(shopOrigin)
      if (utilIndex.getEnv() != 'dev') {
        const apiKey = utilIndex.getApiKey()
        const host = utilIndex.getUrlKey('host') //Shopify 重定向过来中，携带了这些参数
        const shopifyApp = createApp({ apiKey, shopOrigin, host })
        this.$store.commit('setShopifyAppObj', shopifyApp)
      }
    },
    // 刷新路由视图
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    iniWilldesk() {
      var s = document.createElement('script')
      s.setAttribute('data-boot', true); // 加入的标识说明是需要boot以后再加载APP
      s.src = 'https://cdn.willdesk.com/wdc/willdesk.min.js?v='
      s.src += new Date().getTime()
      document.body.appendChild(s)
    },
  },
  computed: {
    listenSetUserName() {
      return this.$store.state.setUserName
    },
  },
  watch: {
    '$route.path': {
      handler(toPath) {
        if (toPath == '/' || toPath.indexOf('/auth') != -1) {
          this.hidden = true
        } else {
          this.hidden = false
        }
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
    '$store.state.willDeskInfo': {
      handler(val) {
        console.log('wiilldeskInfo -----', val)
        if(val.user_id && window.Willdesk) {
          Willdesk.boot(val)
        }
      },
    }
  },
}
</script>
<style scoped>
.nav-bar {
  position: fixed;
  z-index: 100;
  background-color: #f4f6f8;
  top: 0;
  width: 100%;
}
</style>
